import { render } from "./LoginSignup.vue.js?vue&type=template&id=3a47624b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LoginSignup.vue?vue&type=template&id=3a47624b"
import script from "./LoginSignup.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LoginSignup.vue?vue&type=script&lang=js"
export * from "./LoginSignup.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LoginSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/LoginSignup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a47624b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a47624b', __exports__)) {
    api.reload('3a47624b', __exports__)
  }
  
  module.hot.accept("./LoginSignup.vue.js?vue&type=template&id=3a47624b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./LoginSignup.vue?vue&type=template&id=3a47624b", () => {
    api.rerender('3a47624b', render)
  })

}


export default __exports__